module.exports = __webpack_public_path__ + "static/media/05_BOJO_TRIANGULAR_ALCA_REGULAVEL_LISO_09.0f44fe87.jpg";